export default class Presence {
	presence: boolean;

	constructor(presence: boolean) {
		this.presence = presence;
	}
}
